import Avatar from "@mui/material/Avatar";
import { logo } from "utils/assets_exports/images";
import GridViewRoundedIcon from "@mui/icons-material/GridViewRounded";
import ModeSwitch from "./ModeSwitch";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "services/redux/store";
import { closeSideNav, openSideNav } from "services/redux/site";
import AccountDropDown from "./AccountDropDown";

const TopNav = () => {
    const sideNavOpened = useSelector(
        (state: RootState) => state.site.sideNavOpened
    );
    const dispatch = useDispatch<AppDispatch>();

    const toggleSideNav = () => {
        if (sideNavOpened) {
            dispatch(closeSideNav());
        } else {
            dispatch(openSideNav());
        }
    };

    return (
        <div className="shadow-xl bg-white dark:bg-momeento-400">
            <div className="flex flex-row justify-between items-center px-4 py-2 gap-4">
                <div className="hidden md:block">
                    <GridViewRoundedIcon
                        className="text-momeento-50 cursor-pointer"
                        onClick={toggleSideNav}
                    />
                </div>
                <div className="md:hidden">
                    <Avatar
                        alt="text"
                        src={logo}
                        className="cursor-pointer"
                        onClick={toggleSideNav}
                    />
                </div>

                <div className="flex flex-row justify-between items-center w-fit gap-4">
                    <ModeSwitch />
                    <AccountDropDown />
                </div>
            </div>
        </div>
    );
};

export default TopNav;
